import { createStyles } from "@mantine/emotion";

export const useStylesTable = createStyles((theme) => ({
  table: {
    ".mrt-table-container": {
      overflow: "auto",
      maxWidth: "100%",
    },
    table: {
      marginBottom: theme.spacing.table.margin.bottom,
    },
    " .mrt-table-head-sort-button": {
      background: "none",
      svg: {
        stroke: theme.customColors.tableSortIcon,
      },
    },
    ".is-public": {
      paddingLeft: theme.spacing.table.isPublic.padding.left,
    },
    ".css-156re4m": {
      top: "0",
    },
  },
  link: {
    textDecoration: "underline",
    color: theme.customColors.blackLight,
    ":hover": {
      textDecoration: "none",
    },
  },
  toleranceStaticText: {
    backgroundColor: theme.customBackgrounds.table,
    paddingLeft: theme.spacing.table.tolerance.staticText.paddingLeft,
    paddingRight: theme.spacing.table.tolerance.staticText.paddingRight,
    paddingTop: theme.spacing.table.tolerance.staticText.paddingTop,
    paddingBottom: theme.spacing.table.tolerance.staticText.paddingBottom,
    fontSize: theme.spacing.table.tolerance.staticText.fontSize,
  },
  toleranceBodyCell: {
    padding: theme.spacing.table.tolerance.bodyCell.padding,
    textAlign: theme.spacing.table.tolerance.bodyCell.textAlign,
    fontSize: theme.spacing.table.tolerance.bodyCell.fontSize,
  },
  toleranceHeadCell: {
    padding: theme.spacing.table.tolerance.headCell.padding,
    textAlign: theme.spacing.table.tolerance.headCell.textAlign,
    fontSize: theme.spacing.table.tolerance.headCell.fontSize,
    lineHeight: theme.spacing.table.tolerance.headCell.lineHeight,
  },
  toleranceTotalBodyCell: {
    padding: theme.spacing.table.tolerance.totalBodyCell.padding,
    textAlign: theme.spacing.table.tolerance.totalBodyCell.textAlign,
  },
  toleranceTotalHeadCell: {
    padding: theme.spacing.table.tolerance.totalHeadCell.padding,
    textAlign: theme.spacing.table.tolerance.totalHeadCell.textAlign,
    fontSize: theme.spacing.table.tolerance.totalHeadCell.fontSize,

    p: {
      lineHeight: theme.spacing.table.tolerance.totalHeadCell.lineHeight,
    },
  },
}));
